module.exports = __webpack_public_path__ + "img/projector-active.af5e15cf.svg";